module.exports = __webpack_public_path__ + "media/images/holdyourmeeting-ba58dcbfc0abb8e25d8632844ab160f622e84d86e842cd6e468e1ebe462cefdc.jpg";